import { ElLoading, } from "element-plus"
import { createApp, } from "vue"
import { setupAuth, setupDayjs, setupI18n, setupPinia, setupRouter, setupVxeTable, } from "@/setup"
import App from "./App.vue"

import "virtual:uno.css"
import "@/styles/index.scss"
import "animate.css"
// todo
import "element-plus/theme-chalk/index.css"

function setup() {
  const app = createApp(App,)
  setupDayjs()
  setupPinia(app,)
  setupI18n(app,)
  setupVxeTable(app,)
  setupRouter(app,)
  setupAuth(app,)

  app
    .use(ElLoading,)
    .mount("#app",)
  return app
}

setup()
